/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
import { createAction, props } from '@ngrx/store';

export enum ActionTypes {
  GET_USER_PROFILE = '[Account] Update User Profile',
  GET_USER_PROFILE_SUCCESS = '[Account] User Profile Success',
  GET_USER_PROFILE_FAILED = '[Account] User Profile Failed',

  UPDATE_USER_PROFILE = '[Account] Update User Profile',
  UPDATE_USER_PROFILE_SUCCESS = '[Account] Update User Profile Success',
  UPDATE_USER_PROFILE_FAILED = '[Account] User Profile Failed',

  GET_DOCUMENTS = '[Account] Get Documents',
  GET_DOCUMENTS_SUCCESS = '[Account] Get Documents Success',
  GET_DOCUMENTS_FAILED = '[Account] Get Documents Failed',

  GET_QRS = '[Account] Get QRs',
  GET_QRS_SUCCESS = '[Account] Get QRs Success',
  GET_QRS_FAILED = '[Account] Get QRs Failed',

  CHANGE_PASSWORD = '[Account] Change Password',
  CHANGE_PASSWORD_SUCCESS = '[Account] Change Password Success',
  CHANGE_PASSWORD_FAILED = '[Account] Change Password Failed',
}

export const getUserProfile = createAction(
  ActionTypes.GET_USER_PROFILE
);

export const getUserProfileSuccess = createAction(
  ActionTypes.GET_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const updateUserProfile = createAction(
  ActionTypes.UPDATE_USER_PROFILE,
  props<{ data: any }>()
);

export const updateUserProfileSuccess = createAction(
  ActionTypes.UPDATE_USER_PROFILE_SUCCESS,
  props<{ data: any }>()
);

export const getDocuments = createAction(
  ActionTypes.GET_DOCUMENTS,
  props<{ data: any }>()
);

export const getDocumentsSuccess = createAction(
  ActionTypes.GET_DOCUMENTS_SUCCESS,
  props<{ data: any }>()
);

export const getDocumentsFailed = createAction(
  ActionTypes.GET_DOCUMENTS_FAILED,
  props<{ data: any }>()
);

export const getQRs = createAction(
  ActionTypes.GET_QRS
);

export const getQRsSuccess = createAction(
  ActionTypes.GET_QRS_SUCCESS,
  props<{ data: any }>()
);

export const getQRsFailed = createAction(
  ActionTypes.GET_QRS_FAILED,
  props<{ data: any }>()
);

export const changePassword = createAction(
  ActionTypes.CHANGE_PASSWORD,
  props<{ data: any }>()
);

export const changePasswordSuccess = createAction(
  ActionTypes.CHANGE_PASSWORD_SUCCESS,
  props<{ data: any }>()
);

export const changePasswordFailed = createAction(
  ActionTypes.CHANGE_PASSWORD_FAILED,
  props<{ data: any }>()
);